import { AyudaDetailPage } from "../../components/ayuda/page/AyudaDetailPage"
import {
    AyudaPage,
} from "../../pages/admin"

export const nationalRoutes = [
    { path: "/ayuda/*", element: <AyudaPage /> },
    { path: "/ayuda/:id", element: <AyudaDetailPage /> },
]
